import { compact, map, reject, uniq } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import ButtonComponent from './Button';
import './StartingLetter.css';
import TotalComponent from './Total';

const StartingLetter = React.memo(
  ({ shown, size, type, startingWith, filter, alphabet, disableAllItem, onSelectLetter }) => {
    const defaultLetter = disableAllItem ? 'A' : 'ALL';
    const [selectedLetter, setSelectedLetter] = useState(defaultLetter);

    const selectLetter = useCallback(
      (e, letter) => {
        const newLetter = String(letter || defaultLetter).toUpperCase();
        const newLetterValidated =
          alphabet?.indexOf(newLetter) > -1 ? newLetter : defaultLetter;
        setSelectedLetter(newLetterValidated);
        if (e && onSelectLetter) {
          onSelectLetter(e, newLetterValidated);
        }
      },
      [alphabet, onSelectLetter]
    );

    useEffect(() => {
      selectLetter(undefined, startingWith);
    }, [startingWith, selectLetter]);

    const toolTipText = (letter) => {
      if (letter === 'ALL') {
        return 'All items';
      }
      if (letter === '#') {
        return `Items starting with number/symbol`;
      }
      return `Items starting with letter ${letter}`;
    };

    const cleanAlphabet = disableAllItem ? reject(alphabet, (l) => l === 'ALL') : alphabet;
    const letters = compact(uniq(cleanAlphabet));
    return (
      <nav className="startingLetter">
        <TotalComponent shown={shown} size={size} type={type} filter={filter} />
        <ol>
          {map(letters, (letter) => (
            <li key={letter}>
              <ButtonComponent
                id={`startingLetter${letter}`}
                title={letter}
                toolTip={toolTipText(letter)}
                toolTipPosition="top"
                className={selectedLetter === letter ? 'selected' : ''}
                clickButtonEvent="startingLetter"
                clickButtonHandler={selectLetter}
                clickButtonArgs={letter}
              />
            </li>
          ))}
        </ol>
      </nav>
    );
  }
);

StartingLetter.propTypes = {
  shown: PropTypes.number,
  size: PropTypes.number,
  type: PropTypes.string,
  startingWith: PropTypes.string,
  filter: PropTypes.string,
  alphabet: PropTypes.arrayOf(PropTypes.string),
  disableAllItem: PropTypes.bool,
  onSelectLetter: PropTypes.func
};

StartingLetter.defaultProps = {
  shown: 0,
  size: 0,
  type: undefined,
  startingWith: undefined,
  filter: undefined,
  alphabet: [
    'ALL',
    '#',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ],
  disableAllItem: true,
  onSelectLetter: () => {}
};

export default StartingLetter;
